// extracted by mini-css-extract-plugin
module.exports = {"container":"Valid_container__2Lthu","anim":"Valid_anim__32UOa","buttons":"Valid_buttons__2Vral","icon":"Valid_icon__8w-oW"};